module.exports = __webpack_public_path__ + "img/zippo8.e570d0e1.webp";